import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  FirmwareCatalogResponse,
  FirmwareListGetResponse,
  VersionListGetResponse,
} from '../../../shared/interfaces/firmware.interfaces';

const basePath = '/equipment/firmware';

@Injectable({
  providedIn: 'root',
})
export class EquipmentFirmwareService {
  constructor(private http: HttpClient) {}

  // Gets hardware codes and available firmwares from the firmware catalog endpoint.
  getHardwareList(): Observable<FirmwareCatalogResponse> {
    return this.http.get<FirmwareCatalogResponse>(`${basePath}`);
  }

  // Gets the list of all firmware for a given hardware type
  getFirmwareList(hardware: string): Observable<FirmwareListGetResponse[]> {
    const params = new HttpParams().set('hard', hardware);
    return this.http.get<FirmwareListGetResponse[]>(`${basePath}`, { params });
  }

  // Gets the list of all versions for a given hardware and firmware name
  getVersionList(
    hardware: string,
    firmware: string,
  ): Observable<VersionListGetResponse[]> {
    const params = new HttpParams().set('hard', hardware).set('name', firmware);
    return this.http.get<VersionListGetResponse[]>(`${basePath}`, { params });
  }

  // Gets the firmware file for a given hardware, firmware name and version
  getFirmwareFile(
    hardware: string,
    firmware: string,
    version: string,
    platform?: string,
  ): Observable<any> {
    const params = new HttpParams()
      .set('hard', hardware)
      .set('name', firmware)
      .set('version', version)
      .set('platform', platform || 'win32');
    return this.http.get(`${basePath}/file`, { params, responseType: 'blob' });
  }
}
